module.exports = __webpack_public_path__ + "static/media/calendar.0ea0c386.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/calendar.svg
// module id = 583
// module chunks = 0